import { getCustomerPrintTemplate } from "services"
import * as types from "../types/customerPrintTemplate"

export const fetchCustomerPrintTemplate = (branchId) => (
  async (dispatch) => {
    const response = await getCustomerPrintTemplate({ branchId })

    const components =
      !!response
        ? JSON.parse(response.componentsJson)
        : []

    dispatch({
      type: types.FETCH_CUSTOMER_PRINT_TEMPLATE,
      components
    })
  }
)

export const updateCustomerPrintTemplate = (components) => ({
  type: types.UPDATE_CUSTOMER_PRINT_TEMPLATE,
  components
})
